@if ((hasError$ | async) === false) {
  <ng-container>
    @if (configuration$ | async; as configuration) {
      <udex-tile
        class="d-block udex-mt-20 udex-mt-lg-0"
        libGroupSkip
        [groupSkipContent]="true"
        [interactive]="true"
        [href]="'javascript:void(0)'">
        @if (product$ | async; as product) {
          <h2 class="heading__regular--xxxs udex-pb-32 udex-mb-0">
            {{ configuration?.productName || product.name }}
          </h2>
        }
        <div class="price-per-license-wrapper-container">
          @if (showPricePerLicense$ | async) {
            <div
              #pricePerLicenseWrapper
              class="price-per-license-wrapper udex-mb-20"
              [class.price-per-license-wrapper-gradient-top]="showGradientTop"
              [class.price-per-license-wrapper-gradient-bottom]="showGradientBottom"
              (scroll)="checkGradient()">
              @for (item of configuration?.priceSummary?.priceSummaryDCP?.items; track item['materialName']) {
                <div class="price-per-license udex-mb-20">
                  <div class="navigation__medium--xs price-per-license__name">
                    <span>{{ item['materialName'] }}</span>
                    @if (item?.['formattedValues']?.netPriceDescription) {
                      <div
                        class="body--xxs price-per-license__price-description udex-pt-8"
                        [innerHtml]="
                          item['formattedValues'].netPriceDescription
                            ?.split(' | ')
                            ?.join('<br/>')
                            ?.split(' ')
                            ?.join('&nbsp;')
                        "></div>
                    }
                  </div>
                  <div class="text-end navigation__medium--xs">
                    @if (showPriceDiscounts && item['discounts']?.length) {
                      <div class="d-flex justify-content-end flex-wrap udex-pb-4">
                        <span class="body--xxs price-per-license__discounted-price text-decoration-line-through">{{
                          item['formattedValues'].totalListPrice
                        }}</span>
                        <span class="body--xxs price-per-license__discount-text"
                          >&nbsp;&nbsp;-{{ item['discounts'][0].formattedValues?.percentageValue }}</span
                        >
                      </div>
                    }
                    @if (showPartnerDiscounts) {
                      <span class="text-black">{{ item['formattedValues'].totalListPrice }}</span>
                    } @else {
                      <span class="text-black">{{ item['formattedValues'].totalValue }}</span>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div class="subtotal body--xxs udex-pb-20">
          <span class="subtotal__heading text-start">{{ 'configurator.subtotal' | cxTranslate }}</span>

          @if (showPartnerDiscounts) {
            <span class="subtotal__price text-end">{{
              configuratorPriceService.getDcpSubtotalGroup(configuration, 'editions_addons')?.formattedValues
                ?.totalListPrice
            }}</span>
          } @else {
            <span class="subtotal__price text-end">{{ totalValues['editions_addons'] }}</span>
          }
        </div>

        @if (showPartnerDiscounts && totalPartnerDiscountValue) {
          <div class="partner-discount body--xxs udex-pb-20 udex-pt-20">
            <span class="partner-discount__heading text-start">{{ 'configurator.partnerDiscount' | cxTranslate }}</span>
            <span class="partner-discount__price text-end">- {{ totalPartnerDiscountValue }}</span>
          </div>
        }

        @if (recurringDuration && recurringDuration >= 24) {
          <div class="recurring udex-py-20 body--s">
            <span class="recurring__heading body--xs">{{ 'configurator.recurringTotal' | cxTranslate }}:</span>
            <div class="recurring__price text-end">
              <div class="body--s udex-mb-2">
                {{
                  configuratorPriceService.getDcpSubtotalGroup(configuration, 'recurring')?.formattedValues?.netValue
                }}
              </div>
              <div class="recurring__price body--xxs">{{ 'configurator.date.annual' | cxTranslate }}</div>
            </div>
          </div>
        }

        <div class="total udex-my-24">
          <h4 class="total__heading heading__regular--xxs">{{ 'configurator.orderTotal' | cxTranslate }}:</h4>
          <div class="total__price text-end">
            <h4 class="total__price__value heading__medium--xxs udex-m-0">{{ totalValues['all'] }}</h4>
            <div class="total__price__subtext body--xxs udex-mt-4">
              @if (recurringDuration) {
                @switch (true) {
                  @case (recurringDuration > 12) {
                    {{
                      'configurator.date.recurringYears'
                        | cxTranslate
                          : {
                              months: recurringDuration,
                              years: recurringDuration / 12,
                            }
                    }}
                  }
                  @case (recurringDuration == 12) {
                    {{
                      'configurator.date.year'
                        | cxTranslate
                          : {
                              months: recurringDuration,
                            }
                    }}
                  }
                  @case (recurringDuration < 12) {
                    {{
                      'configurator.date.recurringMonths'
                        | cxTranslate
                          : {
                              months: recurringDuration,
                            }
                    }}
                  }
                }
              }
            </div>
          </div>
          <div class="total__price__description body--xxs">
            {{
              (this.configuratorPriceService.isPartnerStore()
                ? 'configurator.psTaxExclusion'
                : showTaxDiscountsCalculationCheckoutMessage
                  ? 'configurator.taxDiscountsCalculationCheckout'
                  : 'configurator.taxCalculationCheckout'
              ) | cxTranslate
            }}
          </div>
        </div>
        @if (
          (showSubtotalsPriceCalculationBreakdown$ | async) &&
          (configuratorPriceService?.getDcpSubtotalGroup(configuration, 'all')?.priceCalculationBreakdown?.length ??
            -1) > 0 &&
          showPerYearPriceCalculationBreakdown
        ) {
          <div class="recurring-subtotal udex-py-20 udex-mt-20">
            <span class="recurring-subtotal__heading navigation__medium--xs udex-mb-4">{{
              'configurator.yearByYearPricingBreakdown' | cxTranslate
            }}</span>
            @if (configuratorPriceService.getDcpSubtotalGroup(configuration, 'all'); as subtotalGroup) {
              @for (
                subtotalPricingItem of subtotalGroup?.priceCalculationBreakdown;
                track subtotalPricingItem?.formattedValues?.totalValue
              ) {
                <span class="recurring-subtotal__year body--xxs"
                  >{{ subtotalPricingItem?.startDate | dcpDate }} - {{ subtotalPricingItem?.endDate | dcpDate }}
                </span>
                <span class="recurring-subtotal__price body--xxs text-end"
                  >{{ subtotalPricingItem?.formattedValues?.totalValue }}
                </span>
              }
            }
          </div>
        }
        <div class="tile-spacer"></div>
      </udex-tile>
    }
  </ng-container>
}
